import { Component, Inject, Input } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { SpecialModule } from 'lib/modules/special.module';
import { BootstrapMarketoService } from 'lib/services/bootstrap/bootstrap-marketo.service';
import { CmsPartialComponentClass } from 'lib/components/cms/cms-partial-component.class';
import { RouterService } from 'lib/services/router.service';
import { WebpService } from 'lib/services/webp.service';
import { CategoryService } from 'lib/services/category/category.service';

@Component({
    selector: 'cms-partial-category-top-lead-gen',
    templateUrl: './lead-gen.component.html',
    styleUrls: ['./lead-gen.component.scss'],
    standalone: true,
    imports: [CommonModule, SpecialModule],
})
export class LeadGenComponent extends CmsPartialComponentClass {
    @Input() leadGenRow: any;
    @Input() dataUrl: string;
    @Input() dataTitle: string;
    @Input() grayBackgroundRows: any = [];
    getWebpImg: (src: string) => string;

    constructor(
        @Inject('environment') environment: any,
        routerService: RouterService,
        public bootstrapMarketoService: BootstrapMarketoService,
        webpService: WebpService,
        location: Location,
        categoryService: CategoryService
    ) {
        super({
            dependencies: {
                bootstrapMarketoService,
                environment,
                routerService,
                location,
                categoryService,
            },
        });
        this.getWebpImg = (src: string) => webpService.getWebpImg(src);
    }
}
